import { weeklyRank } from '@/mocks/manga';
import type { RankItem } from '@/mocks/manga';

const medalColors = ['text-accent-500', 'text-foreground-600', 'text-primary-600'];

function RankRow({ item, index }: { item: RankItem; index: number }) {
  return (
    <a
      href="#featured"
      className="group flex items-center gap-3 rounded-xl px-2 py-2.5 transition-colors hover:bg-background-100"
    >
      <span
        className={`w-7 shrink-0 text-center font-heading text-xl ${
          index < 3 ? medalColors[index] : 'text-foreground-400'
        }`}
      >
        {item.rank}
      </span>
      <div className="h-14 w-10 shrink-0 overflow-hidden rounded-md bg-background-100">
        <img src={item.cover} alt={`${item.title} 封面`} className="h-full w-full object-cover" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-bold text-foreground-950 group-hover:text-primary-600">{item.title}</p>
        <p className="truncate text-xs text-foreground-600">{item.category} · {item.latest}</p>
      </div>
      <div className="hidden flex-col items-end gap-0.5 sm:flex">
        <span className="text-xs font-bold text-primary-600">{item.heat}</span>
        <span className="text-[11px] text-foreground-500">{item.updateTime}</span>
      </div>
      <i className="ri-arrow-right-s-line text-lg text-foreground-400 opacity-0 transition-opacity group-hover:opacity-100"></i>
    </a>
  );
}

export default function UpdateRank() {
  return (
    <section id="rank" className="scroll-mt-20 bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6 lg:col-span-2">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <p className="inline-flex items-center gap-1 rounded-full bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700">
                  <i className="ri-trophy-line text-primary-500"></i>
                  每周热榜
                </p>
                <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">本周更新榜 · TOP 8</h2>
              </div>
              <div className="flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900">
                <i className="ri-refresh-line"></i>
                每周一 00:00 更新
              </div>
            </div>
            <div className="mt-5 divide-y divide-background-100">
              {weeklyRank.map((item, index) => (
                <RankRow key={item.rank} item={item} index={index} />
              ))}
            </div>
          </div>

          <aside className="flex flex-col gap-4">
            <div className="rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6">
              <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-950">
                <i className="ri-cloud-line text-accent-500"></i>
                同步更新说明
              </h3>
              <ul className="mt-4 space-y-3 text-sm text-foreground-700">
                {[
                  { t: '首发 24 小时内', d: '绝大多数新章节完成独家汉化上线' },
                  { t: '未删减高清原版', d: '完整分镜对白，不做任何阉割' },
                  { t: '多端同步阅读', d: '收藏的追更进度自动同步' },
                ].map((it) => (
                  <li key={it.t} className="flex gap-2">
                    <i className="ri-checkbox-circle-fill mt-0.5 text-primary-500"></i>
                    <span>
                      <strong className="font-bold text-foreground-950">{it.t}</strong>：{it.d}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-2xl bg-primary-500 p-5 text-background-50 md:p-6">
              <div className="flex items-center gap-2">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50/20">
                  <i className="ri-bell-fill text-lg"></i>
                </span>
                <h3 className="font-heading text-lg">追更提醒</h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-background-100">
                订阅后，你的追更列表有新章节更新时，第一时间收到提醒，不再错过抢先看。
              </p>
              <a
                href="#about"
                className="mt-4 inline-flex w-full items-center justify-center whitespace-nowrap rounded-full bg-background-50 px-4 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-accent-50"
              >
                <i className="ri-mail-send-line mr-2 text-base"></i>
                去订阅提醒
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}